import { Body, FormControl, Select, SelectItem } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';
import { Controller } from 'react-hook-form';

import { getCandidateDisplayName, getCandidateId } from './helpers';

const PaymentMethodSelect = ({ candidates, control, disabled, errors, label, name, onChange, required }) => {
	const { t } = useTranslation(['signup']);

	return (
		<FormControl formErrors={errors} inputName={name} label={label} required={required}>
			<Controller
				control={control}
				name={name}
				rules={{ required: required && t('signup:auctionAccessLookup.paymentMethodsStep.requiredSelection') }}
				render={({ field: { onBlur, onChange: onFieldChange, ref, value } }) => (
					<Select
						disabled={disabled}
						name={name}
						onBlur={onBlur}
						onChange={(event) => {
							onFieldChange(event);
							onChange?.();
						}}
						placeholder={t('signup:auctionAccessLookup.paymentMethodsStep.select')}
						ref={ref}
						value={value}
					>
						{candidates.map((candidate) => (
							<SelectItem
								key={getCandidateId(candidate)}
								textValue={getCandidateDisplayName(candidate, t)}
								value={getCandidateId(candidate)}
							>
								<Body>{getCandidateDisplayName(candidate, t)}</Body>
							</SelectItem>
						))}
					</Select>
				)}
			/>
		</FormControl>
	);
};

export default PaymentMethodSelect;
